










































































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Error409Modal extends Vue {
  @Prop() private title!: string
  @Prop() private message!: string

  private closeModal () {
    this.$emit('close-modal')
  }
  private doReload () {
    window.location.reload()
  }
}
